import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const gaId = import.meta.env?.VITE_GOOGLE_ANALYTICS_ID;
    
    // Skip if no GA ID configured
    if (!gaId || gaId === 'your-google-analytics-id-here') {
      return;
    }

    // Initialize GA4 script if not already loaded
    if (!window.dataLayer) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      script.async = true;
      document.head?.appendChild(script);

      window.dataLayer = [];
      window.gtag = function gtag(...args) {
        window.dataLayer?.push(args);
      };
      window.gtag('js', new Date());
      window.gtag('config', gaId, {
        send_page_view: false // We'll manually track page views
      });
    }

    // Track page view on route change
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location?.pathname + location?.search,
        page_location: window.location?.href,
        page_title: document.title
      });
    }
  }, [location]);
}

// Helper function to track custom events
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
}

// Helper function to track conversions
export function trackConversion(conversionName, value = null) {
  if (typeof window.gtag !== 'undefined') {
    const params = { event_category: 'conversion' };
    if (value !== null) {
      params.value = value;
    }
    window.gtag('event', conversionName, params);
  }
}